
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Mission from './components/Mission';
import Values from './components/Values';
import Clients from './components/Clients';
import Quality from './components/Quality';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <About />
      <Portfolio />
      <Mission />
      <Values />
      <Clients />
      <Quality />
      <Contact />
      <Footer />
    </div>
  );
}